(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ascendant-calculator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const signOrder = [
      'berbec',
      'taur',
      'gemeni',
      'rac',
      'leu',
      'fecioara',
      'balanta',
      'scorpion',
      'sagetator',
      'capricorn',
      'varsator',
      'pesti'
    ];
    const glyphs = ['♈', '♉', '♊', '♋', '♌', '♍', '♎', '♏', '♐', '♑', '♒', '♓'];
    const elements = [
      'fire',
      'earth',
      'air',
      'water',
      'fire',
      'earth',
      'air',
      'water',
      'fire',
      'earth',
      'air',
      'water'
    ];
    const radians = Math.PI / 180;
    const placeDataCache = new Map();

    const normalizeDegrees = (value) => ((value % 360) + 360) % 360;

    const replaceTokens = (template, values) =>
      Object.entries(values).reduce(
        (result, [token, value]) => result.replaceAll(`__${token}__`, String(value)),
        template
      );

    const foldText = (value) =>
      String(value || '')
        .replaceAll('ş', 'ș')
        .replaceAll('Ş', 'Ș')
        .replaceAll('ţ', 'ț')
        .replaceAll('Ţ', 'Ț')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLocaleLowerCase('ro-RO')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();

    const loadPlaceData = (url) => {
      if (!placeDataCache.has(url)) {
        const request = fetch(url, {
          method: 'GET',
          headers: { Accept: 'application/json' }
        })
          .then((response) => {
            if (!response.ok) throw new Error('location-data-failed');
            return response.json();
          })
          .then((payload) => {
            if (!Array.isArray(payload.places)) throw new Error('location-data-invalid');
            const timezone = payload.timezone || 'Europe/Bucharest';
            return payload.places.map(([name, county, latitude, longitude]) => ({
              name,
              admin1: county === name ? '' : county,
              country: 'România',
              latitude,
              longitude,
              timezone,
              searchName: foldText(name),
              searchCounty: foldText(county)
            }));
          });
        placeDataCache.set(url, request);
      }
      return placeDataCache.get(url);
    };

    const localDateValue = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const zoneParts = (timestamp, timeZone) => {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(new Date(timestamp));

      return Object.fromEntries(
        parts
          .filter((part) => part.type !== 'literal')
          .map((part) => [part.type, Number(part.value)])
      );
    };

    const zoneOffset = (timestamp, timeZone) => {
      const parts = zoneParts(timestamp, timeZone);
      return (
        Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second) -
        timestamp
      );
    };

    const sameWallTime = (parts, wall) =>
      parts.year === wall.year &&
      parts.month === wall.month &&
      parts.day === wall.day &&
      parts.hour === wall.hour &&
      parts.minute === wall.minute;

    const wallTimeToUtc = (wall, timeZone) => {
      const wallTimestamp = Date.UTC(
        wall.year,
        wall.month - 1,
        wall.day,
        wall.hour,
        wall.minute,
        0
      );
      const sampleTimes = [
        wallTimestamp - 43200000,
        wallTimestamp,
        wallTimestamp + 43200000
      ];
      const offsets = [...new Set(sampleTimes.map((timestamp) => zoneOffset(timestamp, timeZone)))];
      const candidates = offsets
        .map((offset) => wallTimestamp - offset)
        .filter((timestamp) => sameWallTime(zoneParts(timestamp, timeZone), wall));

      return [...new Set(candidates)].sort((first, second) => first - second);
    };

    const astronomicalPositions = (utcTimestamp, latitude, longitude) => {
      const julianDay = utcTimestamp / 86400000 + 2440587.5;
      const centuries = (julianDay - 2451545) / 36525;
      const greenwichSidereal = normalizeDegrees(
        280.46061837 +
          360.98564736629 * (julianDay - 2451545) +
          0.000387933 * centuries * centuries -
          (centuries * centuries * centuries) / 38710000
      );
      const localSidereal = normalizeDegrees(greenwichSidereal + longitude);
      const obliquity =
        23.439291111 -
        0.013004167 * centuries -
        0.000000163889 * centuries * centuries +
        0.000000503611 * centuries * centuries * centuries;
      const ascendant = normalizeDegrees(
        Math.atan2(
          -Math.cos(localSidereal * radians),
          Math.sin(obliquity * radians) * Math.tan(latitude * radians) +
            Math.cos(obliquity * radians) * Math.sin(localSidereal * radians)
        ) /
          radians +
          180
      );
      const days = julianDay - 2451545;
      const meanLongitude = normalizeDegrees(280.46 + 0.9856474 * days);
      const meanAnomaly = normalizeDegrees(357.528 + 0.9856003 * days);
      const sunLongitude = normalizeDegrees(
        meanLongitude +
          1.915 * Math.sin(meanAnomaly * radians) +
          0.02 * Math.sin(2 * meanAnomaly * radians)
      );

      return { ascendant, sunLongitude };
    };

    const formattedDegree = (longitude) => {
      const withinSign = normalizeDegrees(longitude) % 30;
      const totalMinutes = Math.min(1799, Math.round(withinSign * 60));
      const degrees = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return `${degrees}° ${String(minutes).padStart(2, '0')}′`;
    };

    const locationLabel = (location) => {
      const values = [location.name, location.admin1, location.country].filter(Boolean);
      return [...new Set(values)].join(', ');
    };

    const validTimeZone = (timeZone) => {
      try {
        new Intl.DateTimeFormat('en-US', { timeZone }).format();
        return true;
      } catch {
        return false;
      }
    };

    const productHasContent = (product) => Boolean(product && product.url && product.title);

    const initAscendantCalculator = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const slot = document.getElementById('ascendant-calculator-slot');
      if (slot && !slot.contains(root)) {
        const wrapper = root.closest('.shopify-section') || root;
        slot.appendChild(wrapper);
      }

      const config = JSON.parse(root.querySelector('[data-ascendant-config]').textContent);
      const form = root.querySelector('[data-ascendant-form]');
      const birthDate = root.querySelector('[data-birth-date]');
      const birthTime = root.querySelector('[data-birth-time]');
      const approximateTime = root.querySelector('[data-approximate-time]');
      const locationInput = root.querySelector('[data-location-input]');
      const locationList = root.querySelector('[data-location-list]');
      const locationStatus = root.querySelector('[data-location-status]');
      const selectedLocationBox = root.querySelector('[data-selected-location]');
      const selectedLocationName = root.querySelector('[data-selected-location-name]');
      const searchIndicator = root.querySelector('[data-search-indicator]');
      const latitudeInput = root.querySelector('[data-latitude]');
      const longitudeInput = root.querySelector('[data-longitude]');
      const timezoneInput = root.querySelector('[data-timezone]');
      const error = root.querySelector('[data-form-error]');
      const calculateButton = root.querySelector('[data-calculate-button]');
      const buttonLabel = root.querySelector('[data-button-label]');
      const result = root.querySelector('[data-ascendant-result]');
      const productCards = [...root.querySelectorAll('[data-product-card]')];
      let selectedLocation = null;
      let suggestions = [];
      let activeSuggestion = -1;
      let searchTimer = null;
      let searchRequest = 0;
      let lastResult = null;

      birthDate.max = localDateValue(new Date());

      const clearError = () => {
        error.textContent = '';
        error.hidden = true;
      };

      const showError = (message) => {
        error.textContent = message;
        error.hidden = false;
      };

      const setLoading = (loading) => {
        calculateButton.disabled = loading;
        buttonLabel.textContent = loading ? config.copy.calculating : config.copy.calculate;
      };

      const closeSuggestions = () => {
        locationList.hidden = true;
        locationInput.setAttribute('aria-expanded', 'false');
        locationInput.removeAttribute('aria-activedescendant');
        activeSuggestion = -1;
      };

      const setActiveSuggestion = (index) => {
        const options = [...locationList.querySelectorAll('[role="option"]')];
        if (!options.length) return;
        activeSuggestion = (index + options.length) % options.length;
        options.forEach((option, optionIndex) => {
          option.setAttribute('aria-selected', String(optionIndex === activeSuggestion));
        });
        const activeOption = options[activeSuggestion];
        locationInput.setAttribute('aria-activedescendant', activeOption.id);
        activeOption.scrollIntoView({ block: 'nearest' });
      };

      const applyLocation = (location) => {
        selectedLocation = location;
        const label = locationLabel(location);
        locationInput.value = label;
        selectedLocationName.textContent = label;
        selectedLocationBox.hidden = false;
        latitudeInput.value = String(location.latitude);
        longitudeInput.value = String(location.longitude);
        timezoneInput.value = location.timezone;
        locationStatus.textContent = '';
        closeSuggestions();
        clearError();
      };

      const renderSuggestions = () => {
        locationList.replaceChildren();
        suggestions.forEach((location, index) => {
          const option = document.createElement('li');
          const primary = document.createElement('strong');
          const secondary = document.createElement('span');
          const detailValues = [location.admin1, location.country].filter(Boolean);

          option.id = `${root.id}-LocationOption-${index}`;
          option.setAttribute('role', 'option');
          option.setAttribute('aria-selected', 'false');
          primary.textContent = location.name;
          secondary.textContent = [...new Set(detailValues)].join(', ');
          option.append(primary, secondary);
          option.addEventListener('mousedown', (event) => {
            event.preventDefault();
            applyLocation(location);
          });
          locationList.appendChild(option);
        });

        locationList.hidden = suggestions.length === 0;
        locationInput.setAttribute('aria-expanded', String(suggestions.length > 0));
        if (suggestions.length) setActiveSuggestion(0);
      };

      const searchLocations = async (query) => {
        const requestId = ++searchRequest;
        searchIndicator.classList.add('is-loading');
        locationStatus.textContent = '';

        try {
          const normalizedQuery = foldText(query);
          const places = await loadPlaceData(config.placesUrl);
          if (requestId !== searchRequest) return;

          suggestions = places
            .map((place) => {
              const combined = `${place.searchName} ${place.searchCounty}`;
              let score = 99;
              if (place.searchName === normalizedQuery) score = 0;
              else if (place.searchName.startsWith(normalizedQuery)) score = 1;
              else if (
                place.searchName.split(' ').some((word) => word.startsWith(normalizedQuery))
              ) {
                score = 2;
              } else if (combined.includes(normalizedQuery)) score = 3;
              return { place, score };
            })
            .filter(({ score }) => score < 99)
            .sort(
              (first, second) =>
                first.score - second.score ||
                first.place.name.length - second.place.name.length ||
                first.place.name.localeCompare(second.place.name, 'ro-RO')
            )
            .slice(0, 8)
            .map(({ place }) => place);
          renderSuggestions();
          if (!suggestions.length) locationStatus.textContent = config.copy.errorNoResults;
        } catch {
          if (requestId !== searchRequest) return;
          suggestions = [];
          closeSuggestions();
          locationStatus.textContent = config.copy.errorSearch;
        } finally {
          if (requestId === searchRequest) {
            searchIndicator.classList.remove('is-loading');
          }
        }
      };

      const manualLocation = () => {
        const latitude = Number(latitudeInput.value);
        const longitude = Number(longitudeInput.value);
        const timeZone = timezoneInput.value.trim();
        const complete =
          latitudeInput.value !== '' &&
          longitudeInput.value !== '' &&
          timeZone !== '' &&
          Number.isFinite(latitude) &&
          Number.isFinite(longitude) &&
          latitude > -90 &&
          latitude < 90 &&
          longitude >= -180 &&
          longitude <= 180 &&
          validTimeZone(timeZone);

        if (!complete) return null;
        return {
          name: locationInput.value.trim() || `${latitude.toFixed(4)}, ${longitude.toFixed(4)}`,
          admin1: '',
          country: '',
          latitude,
          longitude,
          timezone: timeZone
        };
      };

      const parseBirthMoment = (location) => {
        if (!birthDate.value) {
          showError(config.copy.errorMissingDate);
          return null;
        }
        if (!birthTime.value) {
          showError(config.copy.errorMissingTime);
          return null;
        }

        const dateValues = birthDate.value.split('-').map(Number);
        const timeValues = birthTime.value.split(':').map(Number);
        const wall = {
          year: dateValues[0],
          month: dateValues[1],
          day: dateValues[2],
          hour: timeValues[0],
          minute: timeValues[1]
        };
        const checkDate = new Date(
          wall.year,
          wall.month - 1,
          wall.day,
          wall.hour,
          wall.minute
        );
        const validDate =
          wall.year >= 1900 &&
          checkDate.getFullYear() === wall.year &&
          checkDate.getMonth() === wall.month - 1 &&
          checkDate.getDate() === wall.day &&
          checkDate.getHours() === wall.hour &&
          checkDate.getMinutes() === wall.minute;

        if (!validDate) {
          showError(config.copy.errorInvalidDate);
          return null;
        }

        let candidates;
        try {
          candidates = wallTimeToUtc(wall, location.timezone);
        } catch {
          showError(config.copy.errorInvalidLocation);
          return null;
        }

        if (!candidates.length) {
          showError(config.copy.errorLocalTime);
          return null;
        }
        if (candidates[0] > Date.now()) {
          showError(config.copy.errorFutureDate);
          return null;
        }

        return {
          utcTimestamp: candidates[0],
          ambiguous: candidates.length > 1
        };
      };

      const renderProduct = (card, recommendation) => {
        const { product, context, reason } = recommendation;
        const image = card.querySelector('[data-product-image]');
        const imageLink = card.querySelector('[data-product-image-link]');
        const titleLink = card.querySelector('[data-product-title]');
        const button = card.querySelector('[data-product-button]');

        card.querySelector('[data-product-context]').textContent = context;
        card.querySelector('[data-product-reason]').textContent = reason;
        card.querySelector('[data-product-price]').textContent = product.price || '';
        titleLink.textContent = product.title;
        titleLink.href = product.url;
        imageLink.href = product.url;
        button.href = product.url;

        if (product.image) {
          image.src = product.image;
          image.alt = product.title;
          imageLink.hidden = false;
        } else {
          image.removeAttribute('src');
          image.alt = '';
          imageLink.hidden = true;
        }
        card.hidden = false;
      };

      const renderProducts = (sunKey, ascendantKey) => {
        const sunData = config.signs[sunKey];
        const ascendantData = config.signs[ascendantKey];
        const elementKey = elements[signOrder.indexOf(ascendantKey)];
        const elementData = config.elements[elementKey];
        const rawRecommendations = [
          {
            product: ascendantData.product,
            context: config.copy.productForAscendant,
            reason: replaceTokens(config.copy.productReasonAscendant, {
              SIGN: ascendantData.name
            })
          },
          {
            product: sunData.product,
            context: config.copy.productForSun,
            reason: replaceTokens(config.copy.productReasonSun, { SIGN: sunData.name })
          },
          {
            product: elementData.product,
            context: config.copy.productForElement,
            reason: replaceTokens(config.copy.productReasonElement, {
              ELEMENT: elementData.name
            })
          },
          {
            product: config.fallbackProduct,
            context: config.copy.productForElement,
            reason: replaceTokens(config.copy.productReasonElement, {
              ELEMENT: elementData.name
            })
          }
        ];
        const seenUrls = new Set();
        const recommendations = rawRecommendations.filter(({ product }) => {
          if (!productHasContent(product) || seenUrls.has(product.url)) return false;
          seenUrls.add(product.url);
          return true;
        });

        productCards.forEach((card) => {
          card.hidden = true;
        });
        recommendations.slice(0, productCards.length).forEach((recommendation, index) => {
          renderProduct(productCards[index], recommendation);
        });
        root.querySelector('[data-products-section]').hidden = recommendations.length === 0;
      };

      const renderResult = (location, moment, positions) => {
        const sunIndex = Math.floor(positions.sunLongitude / 30);
        const ascendantIndex = Math.floor(positions.ascendant / 30);
        const sunKey = signOrder[sunIndex];
        const ascendantKey = signOrder[ascendantIndex];
        const sunData = config.signs[sunKey];
        const ascendantData = config.signs[ascendantKey];
        const sunElement = elements[sunIndex];
        const ascendantElement = elements[ascendantIndex];
        const elementData = config.elements[ascendantElement];
        const label = locationLabel(location);
        const cuspDistance = Math.min(
          positions.ascendant % 30,
          30 - (positions.ascendant % 30)
        );

        root.querySelector('[data-result-title]').textContent = replaceTokens(
          config.copy.resultPattern,
          { SUN: sunData.name, ASCENDANT: ascendantData.name }
        );
        root.querySelector('[data-result-location]').textContent = replaceTokens(
          config.copy.locationPattern,
          { LOCATION: label }
        );
        root.querySelector('[data-pair-description]').textContent =
          config.pairs[`${sunElement}_${ascendantElement}`] || '';
        root.querySelector('[data-sun-glyph]').textContent = glyphs[sunIndex];
        root.querySelector('[data-sun-name]').textContent = sunData.name;
        root.querySelector('[data-sun-degree]').textContent = replaceTokens(
          config.copy.degreePattern,
          { DEGREE: formattedDegree(positions.sunLongitude), SIGN: sunData.name }
        );
        root.querySelector('[data-ascendant-glyph]').textContent = glyphs[ascendantIndex];
        root.querySelector('[data-ascendant-name]').textContent = ascendantData.name;
        root.querySelector('[data-ascendant-degree]').textContent = replaceTokens(
          config.copy.degreePattern,
          { DEGREE: formattedDegree(positions.ascendant), SIGN: ascendantData.name }
        );
        root.querySelector('[data-profile]').textContent = ascendantData.profile;
        root.querySelector('[data-strengths]').textContent = ascendantData.strengths;
        root.querySelector('[data-advice]').textContent = ascendantData.advice;
        root.querySelector('[data-element]').textContent = elementData.name;
        root.querySelector('[data-stones]').textContent = ascendantData.stones;
        root.querySelector('[data-colors]').textContent = ascendantData.colors;
        root.querySelector('[data-cusp-warning]').hidden = cuspDistance >= 1;
        root.querySelector('[data-approximate-warning]').hidden = !approximateTime.checked;
        root.querySelector('[data-ambiguous-warning]').hidden = !moment.ambiguous;
        root.querySelector('[data-copy-status]').textContent = '';

        renderProducts(sunKey, ascendantKey);
        result.hidden = false;
        lastResult = { sun: sunData.name, ascendant: ascendantData.name };

        document.dispatchEvent(
          new CustomEvent('karmashop:ascendant-calculated', {
            detail: {
              sunSign: sunKey,
              ascendant: ascendantKey,
              element: ascendantElement
            }
          })
        );
        if (Array.isArray(window.dataLayer)) {
          window.dataLayer.push({
            event: 'ascendant_calculated',
            sun_sign: sunKey,
            ascendant_sign: ascendantKey,
            ascendant_element: ascendantElement
          });
        }
      };

      const resultShareText = () =>
        replaceTokens(config.copy.shareText, {
          SUN: lastResult.sun,
          ASCENDANT: lastResult.ascendant
        });

      const copyResult = async () => {
        if (!lastResult) return;
        const text = `${resultShareText()} ${window.location.href}`;
        try {
          await navigator.clipboard.writeText(text);
          root.querySelector('[data-copy-status]').textContent = config.copy.shareSuccess;
        } catch {
          const textArea = document.createElement('textarea');
          textArea.value = text;
          textArea.setAttribute('readonly', '');
          textArea.style.position = 'fixed';
          textArea.style.opacity = '0';
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          textArea.remove();
          root.querySelector('[data-copy-status]').textContent = config.copy.shareSuccess;
        }
      };

      locationInput.addEventListener('input', () => {
        clearTimeout(searchTimer);
        searchRequest += 1;
        searchIndicator.classList.remove('is-loading');
        selectedLocation = null;
        selectedLocationBox.hidden = true;
        locationStatus.textContent = '';
        suggestions = [];
        closeSuggestions();

        const query = locationInput.value.trim();
        if (query.length < 3) return;
        searchTimer = window.setTimeout(() => searchLocations(query), 350);
      });

      locationInput.addEventListener('keydown', (event) => {
        if (locationList.hidden) return;
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          setActiveSuggestion(activeSuggestion + 1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          setActiveSuggestion(activeSuggestion - 1);
        } else if (event.key === 'Enter' && activeSuggestion >= 0) {
          event.preventDefault();
          applyLocation(suggestions[activeSuggestion]);
        } else if (event.key === 'Escape') {
          closeSuggestions();
        }
      });

      locationInput.addEventListener('blur', () => {
        window.setTimeout(closeSuggestions, 120);
      });

      [latitudeInput, longitudeInput, timezoneInput].forEach((input) => {
        input.addEventListener('input', () => {
          selectedLocation = null;
          selectedLocationBox.hidden = true;
          clearError();
        });
      });

      [birthDate, birthTime].forEach((input) => {
        input.addEventListener('input', clearError);
      });

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        clearError();
        setLoading(true);

        window.setTimeout(() => {
          const location = selectedLocation || manualLocation();
          if (!location) {
            const manualHasValue =
              latitudeInput.value || longitudeInput.value || timezoneInput.value.trim();
            showError(
              manualHasValue
                ? config.copy.errorInvalidLocation
                : config.copy.errorMissingLocation
            );
            setLoading(false);
            return;
          }

          const moment = parseBirthMoment(location);
          if (!moment) {
            setLoading(false);
            return;
          }

          const positions = astronomicalPositions(
            moment.utcTimestamp,
            Number(location.latitude),
            Number(location.longitude)
          );
          renderResult(location, moment, positions);
          setLoading(false);
          result.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 30);
      });

      root.querySelector('[data-share-result]').addEventListener('click', async () => {
        if (!lastResult) return;
        if (navigator.share) {
          try {
            await navigator.share({
              title: document.title,
              text: resultShareText(),
              url: window.location.href
            });
          } catch {
            return;
          }
        } else {
          await copyResult();
        }
      });

      root.querySelector('[data-copy-result]').addEventListener('click', copyResult);

      root.querySelector('[data-start-over]').addEventListener('click', () => {
        result.hidden = true;
        lastResult = null;
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        birthDate.focus({ preventScroll: true });
      });
    };

    document.querySelectorAll('[data-ascendant-calculator]').forEach(initAscendantCalculator);
    document.addEventListener('shopify:section:load', (event) => {
      initAscendantCalculator(event.target.querySelector('[data-ascendant-calculator]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucky-numbers-calculator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const toDateInputValue = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const reduceNumber = (number) => {
      let value = Math.abs(number);
      while (value > 9) {
        value = String(value)
          .split('')
          .reduce((sum, digit) => sum + Number(digit), 0);
      }
      return value || 9;
    };

    const randomUnit = () => {
      if (window.crypto && window.crypto.getRandomValues) {
        const value = new Uint32Array(1);
        window.crypto.getRandomValues(value);
        return value[0] / 4294967296;
      }
      return Math.random();
    };

    const zodiacKey = (month, day) => {
      if ((month === 3 && day >= 21) || (month === 4 && day <= 19)) return 'berbec';
      if ((month === 4 && day >= 20) || (month === 5 && day <= 20)) return 'taur';
      if ((month === 5 && day >= 21) || (month === 6 && day <= 20)) return 'gemeni';
      if ((month === 6 && day >= 21) || (month === 7 && day <= 22)) return 'rac';
      if ((month === 7 && day >= 23) || (month === 8 && day <= 22)) return 'leu';
      if ((month === 8 && day >= 23) || (month === 9 && day <= 22)) return 'fecioara';
      if ((month === 9 && day >= 23) || (month === 10 && day <= 22)) return 'balanta';
      if ((month === 10 && day >= 23) || (month === 11 && day <= 21)) return 'scorpion';
      if ((month === 11 && day >= 22) || (month === 12 && day <= 21)) return 'sagetator';
      if ((month === 12 && day >= 22) || (month === 1 && day <= 19)) return 'capricorn';
      if ((month === 1 && day >= 20) || (month === 2 && day <= 18)) return 'varsator';
      return 'pesti';
    };

    const weightedNumbers = (personalDay) => {
      const pool = Array.from({ length: 49 }, (_, index) => index + 1);
      const result = [];

      while (result.length < 6) {
        const weights = pool.map((number) => (reduceNumber(number) === personalDay ? 3 : 1));
        const total = weights.reduce((sum, weight) => sum + weight, 0);
        let target = randomUnit() * total;
        let selectedIndex = 0;

        for (let index = 0; index < pool.length; index += 1) {
          target -= weights[index];
          if (target <= 0) {
            selectedIndex = index;
            break;
          }
        }

        result.push(pool[selectedIndex]);
        pool.splice(selectedIndex, 1);
      }

      return result.sort((first, second) => first - second);
    };

    const sameNumbers = (first, second) =>
      first.length === second.length && first.every((number, index) => number === second[index]);

    const initLuckyNumbers = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const slot = document.getElementById('lucky-numbers-calculator-slot');
      if (slot && !slot.contains(root)) {
        const wrapper = root.closest('.shopify-section') || root;
        slot.appendChild(wrapper);
      }

      const form = root.querySelector('[data-lucky-form]');
      const input = root.querySelector('[data-birth-date]');
      const error = root.querySelector('[data-lucky-error]');
      const result = root.querySelector('[data-lucky-result]');
      const balls = root.querySelector('.lucky-numbers__balls');
      const numberNodes = [...root.querySelectorAll('[data-lucky-number]')];
      const personalDayNode = root.querySelector('[data-personal-day]');
      const zodiacNode = root.querySelector('[data-zodiac-name]');
      const reasonNode = root.querySelector('[data-product-reason]');
      const productCard = root.querySelector('[data-product-card]');
      const productImage = root.querySelector('[data-product-image]');
      const productTitle = root.querySelector('[data-product-title]');
      const productPrice = root.querySelector('[data-product-price]');
      const productLink = root.querySelector('[data-product-link]');
      const todayLabel = root.querySelector('[data-today-label]');
      const copyStatus = root.querySelector('[data-copy-status]');
      const productData = JSON.parse(root.querySelector('[data-lucky-products]').textContent);
      let currentBirthDate = null;
      let currentNumbers = [];

      input.max = toDateInputValue(new Date());

      const showError = (message) => {
        error.textContent = message;
        error.hidden = false;
        input.setAttribute('aria-invalid', 'true');
      };

      const clearError = () => {
        error.textContent = '';
        error.hidden = true;
        input.removeAttribute('aria-invalid');
      };

      const parseBirthDate = () => {
        if (!input.value) {
          showError(root.dataset.errorMissing);
          return null;
        }

        const values = input.value.split('-').map(Number);
        const birthDate = new Date(values[0], values[1] - 1, values[2]);
        const isExactDate =
          birthDate.getFullYear() === values[0] &&
          birthDate.getMonth() === values[1] - 1 &&
          birthDate.getDate() === values[2];

        if (!isExactDate || values[0] < 1900) {
          showError(root.dataset.errorInvalid);
          return null;
        }

        const today = new Date();
        today.setHours(23, 59, 59, 999);
        if (birthDate > today) {
          showError(root.dataset.errorFuture);
          return null;
        }

        clearError();
        return birthDate;
      };

      const renderProduct = (product) => {
        if (!product || !product.url) {
          productCard.hidden = true;
          return;
        }

        productCard.hidden = false;
        productTitle.textContent = `${root.dataset.productTitlePrefix} ${product.name}`;
        productPrice.textContent = product.price;
        productLink.href = product.url;
        if (product.image) {
          productImage.src = product.image;
          productImage.alt = product.title;
          productImage.parentElement.hidden = false;
        } else {
          productImage.removeAttribute('src');
          productImage.alt = '';
          productImage.parentElement.hidden = true;
        }
      };

      const renderCombination = () => {
        if (!currentBirthDate) return;

        const today = new Date();
        const birthDigits = `${currentBirthDate.getFullYear()}${currentBirthDate.getMonth() + 1}${currentBirthDate.getDate()}`;
        const todayDigits = `${today.getFullYear()}${today.getMonth() + 1}${today.getDate()}`;
        const birthNumber = reduceNumber([...birthDigits].reduce((sum, digit) => sum + Number(digit), 0));
        const dayNumber = reduceNumber([...todayDigits].reduce((sum, digit) => sum + Number(digit), 0));
        const personalDay = reduceNumber(birthNumber + dayNumber);

        let nextNumbers = weightedNumbers(personalDay);
        let attempts = 0;
        while (sameNumbers(nextNumbers, currentNumbers) && attempts < 5) {
          nextNumbers = weightedNumbers(personalDay);
          attempts += 1;
        }
        currentNumbers = nextNumbers;

        numberNodes.forEach((node, index) => {
          node.textContent = String(currentNumbers[index]);
        });
        personalDayNode.textContent = String(personalDay);

        const key = zodiacKey(currentBirthDate.getMonth() + 1, currentBirthDate.getDate());
        const product = productData[key];
        zodiacNode.textContent = product.name;
        reasonNode.textContent = product.reason;
        renderProduct(product);

        todayLabel.textContent = new Intl.DateTimeFormat('ro-RO', {
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        }).format(today);

        result.hidden = false;
        copyStatus.textContent = '';
        balls.classList.remove('is-refreshing');
        window.requestAnimationFrame(() => balls.classList.add('is-refreshing'));
      };

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        currentBirthDate = parseBirthDate();
        if (!currentBirthDate) return;
        renderCombination();
        result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });

      root.querySelector('[data-regenerate]').addEventListener('click', renderCombination);

      root.querySelector('[data-copy-numbers]').addEventListener('click', async () => {
        if (!currentNumbers.length) return;
        try {
          await navigator.clipboard.writeText(currentNumbers.join(', '));
          copyStatus.textContent = root.dataset.copySuccess;
        } catch {
          copyStatus.textContent = root.dataset.copyFailed;
        }
      });

      input.addEventListener('input', clearError);
    };

    document.querySelectorAll('[data-lucky-numbers]').forEach(initLuckyNumbers);
    document.addEventListener('shopify:section:load', (event) => {
      initLuckyNumbers(event.target.querySelector('[data-lucky-numbers]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
